import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const LOGO =
  "https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png";

const quickLinks = [
  { label: "Home", href: "https://wifi.com.ng/" },
  { label: "About Us", href: "https://wifi.com.ng/aboutus/" },
  { label: "Services", href: "https://wifi.com.ng/services/" },
  { label: "Pricing", href: "https://wifi.com.ng/newuser/" },
  { label: "Blog", href: "https://wifi.com.ng/blog/" },
];

const socials = [
  { icon: "fa-twitter", href: "https://twitter.com/wificomng" },
  { icon: "fa-facebook", href: "https://facebook.com/wificomng" },
  { icon: "fa-instagram", href: "https://instagram.com/wificomng" },
  { icon: "fa-linkedin-square", href: "https://linkedin.com/company/wificomng" },
];

const plans = [
  { label: "Turbo Connect", href: "#plans" },
  { label: "Turbo Connect Pro", href: "#plans" },
  { label: "Turbo Connect Ultra", href: "#plans" },
];

const scrollToTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5 }}
      className="mt-16 relative bg-brand-dark text-white/90"
    >
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-brand-teal via-brand-green to-brand-teal" />

      <div className="max-w-6xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4 text-left">
        <div className="lg:col-span-1">
          <img
            src={LOGO}
            alt="Wifi.com.ng"
            className="h-16 w-auto bg-white rounded-lg p-2"
          />
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            Reliable, unlimited hybrid internet for homes and businesses
            across Nigeria and beyond.
          </p>
          <div className="flex gap-3 mt-5">
            {socials.map((social) => (
              <motion.a
                key={social.icon}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                whileHover={{ y: -3, scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-brand-teal transition-colors"
              >
                <i className={`fa ${social.icon}`} />
              </motion.a>
            ))}
          </div>
        </div>

        <div>
          <p className="font-semibold text-white">Quick Links</p>
          <ul className="mt-4 space-y-2">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="text-sm text-white/60 hover:text-brand-teal no-underline transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-semibold text-white">Our Plans</p>
          <ul className="mt-4 space-y-2">
            {plans.map((plan) => (
              <li key={plan.label}>
                <a
                  href={plan.href}
                  className="text-sm text-white/60 hover:text-brand-teal no-underline transition-colors"
                >
                  {plan.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-semibold text-white">Get in Touch</p>
          <ul className="mt-4 space-y-2 text-sm text-white/60">
            <li>
              <a
                href="http://wifi.com.ng/contact-us/"
                className="hover:text-brand-teal no-underline transition-colors"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="https://dashboard.tizeti.com/"
                className="hover:text-brand-teal no-underline transition-colors"
              >
                Customer Login
              </a>
            </li>
            <li>
              <Link
                to="/signup"
                className="hover:text-brand-teal no-underline transition-colors"
              >
                Get Started
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-5">
        <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Wifi.com.ng — All rights reserved.
          </p>
          <motion.button
            type="button"
            onClick={scrollToTop}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-1.5 text-xs font-medium text-white/60 hover:text-brand-teal transition-colors"
          >
            Back to top
            <i className="fa fa-arrow-up" />
          </motion.button>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
